export default "__VITE_ASSET__add191f1__"